import { Badge, Button, Group } from '@mantine/core';
import { FC } from 'react';
import { FilterItem } from './FilterModal';

interface FilterBadgeGroupProps {
    items: FilterItem[];
    color: string;
    refine: (value: string) => void;
    renderLabel?: (item: FilterItem) => React.ReactNode;
}

export const FilterBadgeGroup: FC<FilterBadgeGroupProps> = ({
    items,
    color,
    refine,
    renderLabel
}) => {
    const refinedItems = items.filter((item) => item.isRefined);
    
    if (refinedItems.length === 0) return null;
    
    return (
        <Group my="sm">
            {refinedItems.map((item, idx) => (
                <Badge key={idx} color={color}>
                    {renderLabel ? renderLabel(item) : item.label}
                    <Button 
                        variant="subtle" 
                        c="white" 
                        onClick={() => refine(item.value)}
                    >
                        X
                    </Button>
                </Badge>
            ))}
        </Group>
    );
};

export default FilterBadgeGroup;